import { render, staticRenderFns } from "./message_list.vue?vue&type=template&id=03a761a2&scoped=true&"
import script from "./message_list.vue?vue&type=script&lang=js&"
export * from "./message_list.vue?vue&type=script&lang=js&"
import style0 from "./message_list.vue?vue&type=style&index=0&id=03a761a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a761a2",
  null
  
)

export default component.exports